var _style, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#FFFFFF;stroke:#FDB847;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2.4,20.6c-1.3,0-2.3-1-2.4-2.3c0,0,0-0.1,0-0.1V2.4C0,1.1,1,0,2.3,0c0,0,0.1,0,0.1,0h15.8 c1.3,0,2.3,1,2.4,2.3c0,0,0,0.1,0,0.1v15.8c0,1.3-1,2.3-2.3,2.4c0,0-0.1,0-0.1,0H2.4z M2.9,2.9L2.9,2.9z M31.8,20.6 c-1.3,0-2.3-1-2.4-2.3c0,0,0-0.1,0-0.1V2.4c0-1.3,1-2.3,2.3-2.4c0,0,0.1,0,0.1,0h15.8C48.9,0,50,1,50,2.3c0,0,0,0.1,0,0.1v15.8 c0,1.3-1,2.3-2.3,2.4c0,0-0.1,0-0.1,0H31.8z M32.4,2.9L32.4,2.9z M2.4,50C1.1,50,0,49,0,47.7c0,0,0-0.1,0-0.1V31.8 c0-1.3,1-2.3,2.3-2.4c0,0,0.1,0,0.1,0h15.8c1.3,0,2.3,1,2.4,2.3c0,0,0,0.1,0,0.1v15.8c0,1.3-1,2.3-2.3,2.4c0,0-0.1,0-0.1,0H2.4z  M2.9,32.3L2.9,32.3z M39.7,50c-0.4,0-0.8-0.1-1-0.4c-0.3-0.3-0.4-0.6-0.4-1v-7.4h-7.4c-0.4,0-0.7-0.1-1-0.4 c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.7,0.4-1c0.3-0.3,0.6-0.4,1-0.4h7.4v-7.5c0-0.4,0.1-0.7,0.4-1c0.3-0.3,0.7-0.4,1-0.4 c0.4,0,0.7,0.2,1,0.4c0.3,0.3,0.4,0.6,0.4,1v7.4h7.5c0.4,0,0.7,0.1,1,0.4c0.3,0.3,0.4,0.7,0.4,1.1c0,0.4-0.2,0.7-0.4,1 c-0.3,0.3-0.6,0.4-1,0.4h-7.4v7.5c0,0.4-0.2,0.7-0.4,1C40.5,49.9,40.1,50,39.7,50 M32.3,2.9v14.7h14.7V2.9H32.3z M2.9,2.9v14.7 h14.7V2.9H2.9z M2.9,32.3v14.7h14.7V32.3H2.9z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.2,2.7c1.4-1.3,3.6-1.3,5,0l17.6,16.6c1.1,1,1.7,2.5,1.7,4v20.2c0,3-2.4,5.4-5.4,5.4h-7.3 c-3,0-5.4-2.4-5.4-5.4c0,0,0,0,0,0v-9.1c0-1-0.8-1.8-1.8-1.8h-3.6c-1,0-1.8,0.8-1.8,1.8v9.1c0,3-2.4,5.4-5.4,5.4H9.3 c-3,0-5.4-2.4-5.4-5.4V23.3c0-1.5,0.6-2.9,1.7-4L23.2,2.7z M25.7,5.4L8.1,22c-0.4,0.3-0.6,0.8-0.6,1.3v20.2c0,1,0.8,1.8,1.8,1.8h7.3 c1,0,1.8-0.8,1.8-1.8v-9.1c0-3,2.4-5.4,5.4-5.4h3.6c3,0,5.4,2.4,5.4,5.4v9.1c0,1,0.8,1.8,1.8,1.8H42c1,0,1.8-0.8,1.8-1.8V23.3 c0-0.5-0.2-1-0.6-1.3L25.7,5.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.c52c60292a489f0fb0a33d0971a6203b.svg";
export { ForwardRef as ReactComponent };